import styled, { keyframes } from 'styled-components';
import { themeColors } from '../../themes';
import { useSocialFeedSettings } from '../../utils';

interface LoaderProps {
  size?: number;
  color?: string;
}

export function Loader({ color, size = 40, ...forwardingProps }: LoaderProps) {
  const {
    theme: { type: themeType }
  } = useSocialFeedSettings();

  const defaultColor =
    themeType === 'light' ? themeColors.blackColor : themeColors.lightColor;
  const finalColor = color || defaultColor;

  return (
    <Container {...forwardingProps}>
      <Spinner _size={size} _color={finalColor} />
    </Container>
  );
}

const spinning = keyframes`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<{
  _size: number;
  _color: string;
}>`
  width: ${({ _size }) => _size}px;
  height: ${({ _size }) => _size}px;
  border-color: ${({ _color }) => _color};
  border-top-color: transparent;
  display: block;
  border-style: solid;
  border-radius: 50%;
  border-width: 2px;
  animation: ${spinning} 1s infinite linear;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
